// Obras that can be drawn on the map: valid ubicacionMaps, exposed as numeric lat/lng.
export function obrasConUbicacion(obras) {
  return (obras || []).flatMap((obra) => {
    const lat = Number(obra?.ubicacionMaps?.lat);
    const lng = Number(obra?.ubicacionMaps?.lng);
    if (obra?.ubicacionMaps == null || !Number.isFinite(lat) || !Number.isFinite(lng)) return [];
    return [{ ...obra, lat, lng }];
  });
}
